import { http, HttpResponse } from 'msw';
import { PlessService } from '../../app/shared/pless-service.model';
import { ResponseUtils } from './response-utils';

export const kymw68Handlers = [
    // カテゴリ一覧取得 /kymw68/get68CategoryInfo
    http.post(PlessService.SERVICE.get68CategoryInfo.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.get68CategoryInfo.url, req);
        return HttpResponse.json(get68CategoryInfoResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),

    // カテゴリ変換マスタ一覧取得 /kymw68/getCategoryConvList
    http.post(PlessService.SERVICE.getCategoryConvList.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.getCategoryConvList.url, req);
        return HttpResponse.json(getCategoryConvListResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),

    // カテゴリ変換マスタ設定削除 /kymw68/deleteCategoryConvInfo
    http.post(PlessService.SERVICE.deleteCategoryConvInfo.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.deleteCategoryConvInfo.url, req);
        return HttpResponse.json(deleteCategoryConvInfoResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // カテゴリ変換マスタ設定取得 /kymw68/getCategoryConvInfo
    http.post(PlessService.SERVICE.getCategoryConvInfo.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.getCategoryConvInfo.url, req);
        return HttpResponse.json(getCategoryConvInfoResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // カテゴリ変換マスタ設定登録 /kymw68/registCategoryConvInfo
    http.post(PlessService.SERVICE.registCategoryConvInfo.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.registCategoryConvInfo.url, req);
        return HttpResponse.json(registCategoryConvInfoResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // カテゴリ変換マスタ設定更新 /kymw68/updateCategoryConvInfo
    http.post(PlessService.SERVICE.updateCategoryConvInfo.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.updateCategoryConvInfo.url, req);
        return HttpResponse.json(updateCategoryConvInfoResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // カテゴリ変換マスタ一覧出力 /kymw68/saveCwsCategoryConvList
    http.post(PlessService.SERVICE.saveCwsCategoryConvList.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.saveCwsCategoryConvList.url, req);
        return HttpResponse.json(saveCwsCategoryConvListResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    http.post(PlessService.SERVICE.KYMW68getConvDivList.url, async ({ request }) => {
        const req = await request.json();
        return HttpResponse.json(getConvDivListResponse);
        // return new HttpResponse('Internal Server Error', { status: 500 });
    }),
    http.post(PlessService.SERVICE.KYMW68getFeatureList.url, async ({ request }) => {
        const req = await request.json();
        return HttpResponse.json(getFeatureListResponse);
        // return new HttpResponse('Internal Server Error', { status: 500 });
    }),
];

const get68CategoryInfoResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            CategoryDiv: '1',
            OrderCode: '',
            Category: [
                {
                    OrderCode: '',
                    CategoryCode: '111000000',
                    CategoryName: '予約',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 1,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '0',
                    Category: [
                        {
                            OrderCode: '',
                            CategoryCode: '111001000',
                            CategoryName: 'ボジョレー・ヌーヴォー予約',
                            ParentCategoryCode: '111000000',
                            CategoryLevel: 2,
                            ShowSeq: 1,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '111002000',
                            CategoryName: '１２－３減塩、少量おせちなど',
                            ParentCategoryCode: '111000000',
                            CategoryLevel: 2,
                            ShowSeq: 2,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '1',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '111003000',
                            CategoryName: '１２－３海鮮ごちそう',
                            ParentCategoryCode: '111000000',
                            CategoryLevel: 2,
                            ShowSeq: 3,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '1',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '111004000',
                            CategoryName: '１２－３お肉のごちそう・中華',
                            ParentCategoryCode: '111000000',
                            CategoryLevel: 2,
                            ShowSeq: 4,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '111005000',
                            CategoryName: '１２－３年越しそば・餅・雑煮',
                            ParentCategoryCode: '111000000',
                            CategoryLevel: 2,
                            ShowSeq: 5,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '0',
                        },
                    ]
                },
                {
                    OrderCode: '',
                    CategoryCode: '114000000',
                    CategoryName: '特集②',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 2,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00000000',
                    SellAreaDivN: '00000000',
                    SellAreaDivM: '00000000',
                    SellAreaDivW: '00000000',
                    UpdateDate: '',
                    TimeSaleFlg: '1',
                    StockLimitFlg: '0',
                    Category: [
                        {
                            OrderCode: '',
                            CategoryCode: '114001000',
                            CategoryName: '新茶予約',
                            ParentCategoryCode: '114000000',
                            CategoryLevel: 2,
                            ShowSeq: 1,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '1',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '114002000',
                            CategoryName: 'うなぎ予約',
                            ParentCategoryCode: '114000000',
                            CategoryLevel: 2,
                            ShowSeq: 2,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '1',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '114003000',
                            CategoryName: 'ボジョレー予約',
                            ParentCategoryCode: '114000000',
                            CategoryLevel: 2,
                            ShowSeq: 3,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '1',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '114004000',
                            CategoryName: 'その他４',
                            ParentCategoryCode: '114000000',
                            CategoryLevel: 2,
                            ShowSeq: 4,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00000000',
                            SellAreaDivN: '00000000',
                            SellAreaDivM: '00000000',
                            SellAreaDivW: '00000000',
                            UpdateDate: '',
                            TimeSaleFlg: '1',
                            StockLimitFlg: '0',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '114005000',
                            CategoryName: 'その他１２',
                            ParentCategoryCode: '114000000',
                            CategoryLevel: 2,
                            ShowSeq: 5,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00000000',
                            SellAreaDivN: '00000000',
                            SellAreaDivM: '00000000',
                            SellAreaDivW: '00000000',
                            UpdateDate: '',
                            TimeSaleFlg: '1',
                            StockLimitFlg: '0',
                        },
                    ]
                },
                {
                    OrderCode: '',
                    CategoryCode: '036000000',
                    CategoryName: 'ＳＡＬＥ',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 3,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '1',
                    Category: [
                        {
                            OrderCode: '',
                            CategoryCode: '036001000',
                            CategoryName: 'くらし応援',
                            ParentCategoryCode: '036000000',
                            CategoryLevel: 2,
                            ShowSeq: 1,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '1',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '036002000',
                            CategoryName: 'スーパープライス',
                            ParentCategoryCode: '036000000',
                            CategoryLevel: 2,
                            ShowSeq: 2,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '1',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '036003000',
                            CategoryName: '上半期最安値',
                            ParentCategoryCode: '036000000',
                            CategoryLevel: 2,
                            ShowSeq: 3,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '1',
                        },
                        {
                            OrderCode: '',
                            CategoryCode: '036004000',
                            CategoryName: '期間限定　価格すえおき',
                            ParentCategoryCode: '036000000',
                            CategoryLevel: 2,
                            ShowSeq: 4,
                            BorderLineDiv: '0',
                            ShowDiv: '0',
                            SellAreaDivB: '00010111',
                            SellAreaDivN: '00010111',
                            SellAreaDivM: '00010111',
                            SellAreaDivW: '00010111',
                            UpdateDate: '',
                            TimeSaleFlg: '0',
                            StockLimitFlg: '1',
                        },
                    ]
                },
                {
                    OrderCode: '',
                    CategoryCode: '046000000',
                    CategoryName: '同一商品２点以上でお得',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 4,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '1',
                },
                {
                    OrderCode: '',
                    CategoryCode: '049000000',
                    CategoryName: 'ポイント利用商品',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 5,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '1',
                },
                {
                    OrderCode: '',
                    CategoryCode: '048000000',
                    CategoryName: 'わくわくポイント',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 6,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '1',
                },
                {
                    OrderCode: '',
                    CategoryCode: '039000000',
                    CategoryName: '今週の新登場',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 7,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '1',
                },
                {
                    OrderCode: '',
                    CategoryCode: '161000000',
                    CategoryName: '今しか買えない！今回限りなど',
                    ParentCategoryCode: '',
                    CategoryLevel: 1,
                    ShowSeq: 8,
                    BorderLineDiv: '0',
                    ShowDiv: '0',
                    SellAreaDivB: '00010111',
                    SellAreaDivN: '00010111',
                    SellAreaDivM: '00010111',
                    SellAreaDivW: '00010111',
                    UpdateDate: '',
                    TimeSaleFlg: '0',
                    StockLimitFlg: '1',
                },
            ]
        },
    },
};

const getCategoryConvListResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            Category: {
                List: [
                    {
                        CategoryConvID: '3988',
                        CategoryCode: '036001000：くらし応援',
                        CategoryDiv: '2：CWS商品企画カテゴリ',
                        ConvDiv: '01：部門×分類',
                        ClassDivNum: '10',
                        ClassCode: '01：農産',
                        LargeClassCode: '03：野菜１',
                        MiddleClassCode: '0303：葉菜',
                        SmallClassCode: '030300：ほうれん草',
                        MarkCode1: '012：０１：くらし応援',
                        MarkCode2: '013：０１：くらし応援 さらにお得',
                        MarkCode3: '014：０１：週次テーマ１',
                        PricePattern: '0：通常',
                        MediumType: '003：ぐるめぐり',
                        FeatureCode: '11111：特集名',
                        PageNum: '45',
                        PromotionDiv: 'T：わくわくポイント',
                        PromotionInfo: '10：わくわく１０ポイント',
                        ExhibitionDiv: '00400000',
                        Tag1: '55555555：タグ５',
                        Tag2: '11111111：タグ１',
                    },
                    {
                        CategoryConvID: '3988',
                        CategoryCode: '036001000：くらし応援',
                        CategoryDiv: '2：CWS商品企画カテゴリ',
                        ConvDiv: '01：部門×分類',
                        ClassDivNum: '10',
                        ClassCode: '01：農産',
                        LargeClassCode: '03：野菜１',
                        MiddleClassCode: '0303：葉菜',
                        SmallClassCode: '030300：ほうれん草',
                        MarkCode1: '012：０１：くらし応援',
                        MarkCode2: '013：０１：WWWWWWWWWWWWWWWWWWWWWWWWW',
                        MarkCode3: '014：０１：週次テーマ１',
                        PricePattern: '0：通常',
                        MediumType: '003：ぐるめぐり',
                        FeatureCode: '11111：特集名',
                        PageNum: '45',
                        PromotionDiv: 'T：わくわくポイント',
                        PromotionInfo: '10：わくわく１０ポイント',
                        ExhibitionDiv: '00400000',
                        Tag1: '55555555：タグ５',
                        Tag2: '11111111：タグ１',
                    },
                    {
                        CategoryConvID: '3988',
                        CategoryCode: '036001000：くらし応援',
                        CategoryDiv: '2：CWS商品企画カテゴリ',
                        ConvDiv: '01：部門×分類',
                        ClassDivNum: '10',
                        ClassCode: '01：農産',
                        LargeClassCode: '03：野菜１',
                        MiddleClassCode: '0303：葉菜',
                        SmallClassCode: '030300：ほうれん草',
                        MarkCode1: '012：０１：くらし応援',
                        MarkCode2: '013：０１：くらし応援 さらにお得',
                        MarkCode3: '014：０１：週次テーマ１',
                        PricePattern: '0：通常',
                        MediumType: '003：ぐるめぐり',
                        FeatureCode: '11111：特集名',
                        PageNum: '45',
                        PromotionDiv: 'T：わくわくポイント',
                        PromotionInfo: '10：わくわく１０ポイント',
                        ExhibitionDiv: '00400000',
                        Tag1: '55555555：タグ５',
                        Tag2: '11111111：タグ１',
                    },
                    {
                        CategoryConvID: '3988',
                        CategoryCode: '036001000：くらし応援',
                        CategoryDiv: '2：CWS商品企画カテゴリ',
                        ConvDiv: '01：部門×分類',
                        ClassDivNum: '10',
                        ClassCode: '01：農産',
                        LargeClassCode: '03：野菜１',
                        MiddleClassCode: '0303：葉菜',
                        SmallClassCode: '030300：ほうれん草',
                        MarkCode1: '012：０１：くらし応援',
                        MarkCode2: '013：０１：くらし応援 さらにお得',
                        MarkCode3: '014：０１：週次テーマ１',
                        PricePattern: '0：通常',
                        MediumType: '003：ぐるめぐり',
                        FeatureCode: '11111：特集名',
                        PageNum: '45',
                        PromotionDiv: 'T：わくわくポイント',
                        PromotionInfo: '10：わくわく１０ポイント',
                        ExhibitionDiv: '00400000',
                        Tag1: '55555555：タグ５',
                        Tag2: '11111111：タグ１',
                    },
                    {
                        CategoryConvID: '3988',
                        CategoryCode: '036001000：くらし応援',
                        CategoryDiv: '2：CWS商品企画カテゴリ',
                        ConvDiv: '01：部門×分類',
                        ClassDivNum: '10',
                        ClassCode: '01：農産',
                        LargeClassCode: '03：野菜１',
                        MiddleClassCode: '0303：葉菜',
                        SmallClassCode: '030300：ほうれん草',
                        MarkCode1: '012：０１：くらし応援',
                        MarkCode2: '013：０１：くらし応援 さらにお得',
                        MarkCode3: '014：０１：週次テーマ１',
                        PricePattern: '0：通常',
                        MediumType: '003：ぐるめぐり',
                        FeatureCode: '11111：特集名',
                        PageNum: '45',
                        PromotionDiv: 'T：わくわくポイント',
                        PromotionInfo: '10：わくわく１０ポイント',
                        ExhibitionDiv: '00400000',
                        Tag1: '55555555：タグ５',
                        Tag2: '11111111：タグ１',
                    },
                ]
            }
        },
    },
};

const deleteCategoryConvInfoResponse = {
    status: 'ok',
    message: '処理完了',
};

// 修正処理の際は選択したデータをリストから取得するためからデータを返却する
const getCategoryConvInfoResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            CategoryConvID: '3988',
            CategoryCode: '036001000',
            CategoryDiv: '2',
            ConvDiv: '01',
            ClassDivNum: '10',
            ClassCode: '01',
            LargeClassCode: '03',
            MiddleClassCode: '0303',
            SmallClassCode: '030300',
            MarkCode1: '012',
            MarkCode2: '013',
            MarkCode3: '014',
            PricePattern: '0',
            MediumType: '003',
            FeatureCode: '11111',
            PageNum: '45',
            PromotionDiv: 'T',
            PromotionInfo: '10',
            ExhibitionDiv: '00400000',
            UpdateDate: '2025/05/19 00:00:00',
            Tag1: '55555555',
            Tag2: '11111111',
        }
    }
};

const registCategoryConvInfoResponse = {
    status: 'ok',
    message: '処理完了',
};

const updateCategoryConvInfoResponse = {
    status: 'ok',
    message: '処理完了',
};

const saveCwsCategoryConvListResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            FileName: '/tmp/peace/data/WebData/downloadtemp/a1850eb1-dda2-46d2-845b-2203a20b6f44/ECカテゴリ変換マスタ一覧出力_20241222201334.tsv'
        }
    }
};

const getConvDivListResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
      obj: [
        {
          CategoryDiv: '1',
          ConvDiv: '01',
          ConvName: '部門×分類',
          ClassCodeCtrl: '1',
          LargeClassCodeCtrl: '1',
          MiddleClassCodeCtrl: '1',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '1',
          ConvDiv: '28',
          ConvName: '部門×分類×タグ',
          ClassCodeCtrl: '1',
          LargeClassCodeCtrl: '1',
          MiddleClassCodeCtrl: '1',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '29',
          ConvName: '媒体×特集（最新企画回）',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '1',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '1',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '30',
          ConvName: '価格パターン',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '1',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '31',
          ConvName: '価格パターン×媒体',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '1',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '1',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '32',
          ConvName: '価格パターン×媒体×ページ',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '1',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '1',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '1',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '33',
          ConvName: '価格パターン×部門×分類（中分類/小分類）',
          ClassCodeCtrl: '1',
          LargeClassCodeCtrl: '1',
          MiddleClassCodeCtrl: '1',
          SmallClassCodeCtrl: '1',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '1',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '34',
          ConvName: '価格パターン×マーク',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '1',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '1',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '0',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '35',
          ConvName: '価格パターン×タグ',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '1',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '1',
          ConvDiv: '36',
          ConvName: 'タグ',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '1',
          ConvDiv: '37',
          ConvName: 'タグ１×タグ２',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '1',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '38',
          ConvName: 'タグ×媒体',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '1',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '39',
          ConvName: 'タグ×媒体×ページ',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '1',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '1',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '1',
          ConvDiv: '40',
          ConvName: 'タグ×部門×分類（中分類/小分類）',
          ClassCodeCtrl: '1',
          LargeClassCodeCtrl: '1',
          MiddleClassCodeCtrl: '1',
          SmallClassCodeCtrl: '1',
          MarkCode1Ctrl: '0',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
        {
          CategoryDiv: '2',
          ConvDiv: '41',
          ConvName: 'タグ×マーク',
          ClassCodeCtrl: '0',
          LargeClassCodeCtrl: '0',
          MiddleClassCodeCtrl: '0',
          SmallClassCodeCtrl: '0',
          MarkCode1Ctrl: '1',
          MarkCode2Ctrl: '0',
          MarkCode3Ctrl: '0',
          MediumTypeCtrl: '0',
          PromotionDivCtrl: '0',
          PromotionInfoCtrl: '0',
          PageNumCtrl: '0',
          ExhibitionDivCtrl: '0',
          PricePatternCtrl: '0',
          FeatureCodeCtrl: '0',
          Tag1Ctrl: '1',
          Tag2Ctrl: '0',
        },
      ],
    },
};

const getFeatureListResponse = {
    status: "ok",
    message: "処理終了",
    result: {
      obj: {
        FeatureList: [
          {
            FeatureCode: '11111',
            FeatureName: '特集名'
          },
          {
            FeatureCode: '22222',
            FeatureName: '特集２'
          },
          {
            FeatureCode: '33333',
            FeatureName: '特集３'
          },
          {
            FeatureCode: '44444',
            FeatureName: '特集４'
          },
          {
            FeatureCode: '55555',
            FeatureName: '特集５'
          },
        ]
      }
    }
  }